import { MemberCreditListResponse } from '../dto/ResDtoRepository';
import { sendApiRequest, sendGetApiRequest } from './apiConfig';

export const getMemberCreditList = async (
  aui: string,
): Promise<MemberCreditListResponse> =>
  sendGetApiRequest<MemberCreditListResponse>(
    `/api/v1/member-credit/list?aui=${encodeURIComponent(aui)}`,
  );

export const getMemberCreditListOwner = async (
  aui: string,
): Promise<MemberCreditListResponse> =>
  sendApiRequest<MemberCreditListResponse>(
    'get',
    `/api/v1/member-credit/list/owner?aui=${encodeURIComponent(aui)}`,
  );
